import React from "react";
import x_gray from '../../assets/images/x_gray.svg';

const ScrollableBox = ({ children, id, maxHeight="auto", width="auto", track_color="#e1e1e1", thumb_color="#888", thumb_hover_color="#555", background="white", display="none", clearable=false }) => {
    const boxStyle = {
      maxHeight: maxHeight,
      width: width,
      overflow: 'auto',
      border: '1px solid #ccc',
      padding: '10px',
      boxSizing: 'border-box',
      borderRadius: '10px',
      background: background,
      display: display,
  
      // Scrollbar styles for Webkit browsers
      '::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
      },
      '::-webkit-scrollbar-track': {
        background: track_color,
        borderRadius: '10px',
      },
      '::-webkit-scrollbar-thumb': {
        background: thumb_color,
        borderRadius: '10px',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: thumb_hover_color,
      },
    };

    let style_str = `.scrollableBox::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      .scrollableBox::-webkit-scrollbar-track {
        background: ` + track_color + `;
        border-radius: 10px;
      }
      .scrollableBox::-webkit-scrollbar-thumb {
        background: ` + thumb_color +`;
        border-radius: 10px;
      }
      .scrollableBox::-webkit-scrollbar-thumb:hover {
        background: ` + thumb_hover_color + `;
      }
    .close-icon {
      position: absolute;
      right: 20px;
      cursor: pointer;
    }`
    
    const handleClose = () => {
        const box = document.getElementById("scrollable_info_popup");
        if (box) {
          box.style.display = 'none';
        }
      };

    return (
      <>
        <style>
          {style_str}
        </style>
        <div id={id} className="scrollableBox" style={boxStyle}> 
          {clearable ? <span className="close-icon" onClick={handleClose}><img src={x_gray}/></span> : ""}
          {children}
        </div>
      </>
    );
  };
  
  export default ScrollableBox;